type EventName =
  | "Waitlist_Open"
  | "Waitlist_Submit"
  | "Pricing_View"
  | "CTA_Click"
  | "Scroll_Depth"
  | "Exit_Intent";

export function trackEvent(name: EventName, props?: Record<string, string | number | boolean>) {
  if (typeof window !== "undefined" && typeof window.plausible === "function") {
    window.plausible(name, props ? { props } : undefined);
  }
}
